// ErrorContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';
import ModalMessageValid from '../../components/modal/modalMessageValid';

type ModalContextType = {
    showModal: (message: string) => void;
};

const ModalContext = createContext<ModalContextType | undefined>(undefined);

type ModalProviderProps = {
    children: ReactNode;
};

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
    const [modalValid, setModalValid] = useState<string | null>(null);

    const showModal = (message: string) => {
        setModalValid(message);
    };

    const handleClose = () => {
        setModalValid(null);
    };

    return (
        <ModalContext.Provider value={{ showModal }}>
            {children}
            {modalValid && <ModalMessageValid modalMessage={modalValid} onClose={handleClose} />}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (context === undefined) {
        throw new Error('useError must be used within an ModalProvider');
    }
    return context;
};